import type { RestGetPermissionGroup } from "@KassaroAB/shared/types/PermissionGroup";
import { api } from "../utils/api";
import type { ChainId } from "@KassaroAB/shared/types/ids";

export const getPermissionGroupsApi = async (
  chainId: ChainId,
): Promise<RestGetPermissionGroup[]> => {
  return api.get(`chains/${chainId}/permissionGroups`);
};
